import React from 'react';
import GalleryGrid from '../components/gallery/GalleryGrid';

const GalleryPage = () => {
  return <GalleryGrid />;
};

export default GalleryPage;
